import { render, staticRenderFns } from "./subPageSix.vue?vue&type=template&id=26bd8236&scoped=true"
var script = {}
import style0 from "./subPageSix.vue?vue&type=style&index=0&id=26bd8236&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26bd8236",
  null
  
)

export default component.exports